'use client';

import { useTranslations } from 'next-intl';
import { ImageTextSection } from '@/components/design-system/ImageTextSection';
import ProductsForm from '@/components/google-forms/ProductsForm';

export default function() {
  const t = useTranslations('producers');
  return (
    <>
      <div className="section-container pb-8">
        <ImageTextSection
          title={t('producers-title-2')}
          imageOrder="left"
          imageUrl="winelivery_vendere_vino.png"
        >
          <p>{t.rich('producers-paragraph-1', { b: (c) => <b>{c}</b> })}</p>
          <p className="mb-0">{t('producers-paragraph-2')}</p>
          <p>{t('producers-paragraph-3')}</p>
        </ImageTextSection>

        <ImageTextSection title={t('why-title')}>
          <ul className="list-disc text-sm text-gray-500">
            <li>{t.rich('why-list-1', { b: (c) => <b>{c}</b> })}</li>
            <li>{t.rich('why-list-2', { b: (c) => <b>{c}</b> })}</li>
            <li>{t.rich('why-list-3', { b: (c) => <b>{c}</b> })}</li>
          </ul>
        </ImageTextSection>

        <div className="mt-4">
          <h3 className="mb-8">
            {t.rich('producers-fill-form', { b: (c) => <b>{c}</b> })}
          </h3>
          <ProductsForm />
        </div>
      </div>
    </>
  );
}
